document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', function() {
      const variant = this.dataset.variant;
      const mainImage = document.querySelector('.product__media img'); // Vérifie ce sélecteur
      const imgSrc = this.style.backgroundImage.replace(/url\("|"\)/g, '');
      if(mainImage) {
        mainImage.src = imgSrc;
      }

      const select = document.querySelector('select[name="id"]');
      if(select) {
        for(let i = 0; i < select.options.length; i++) {
          if(select.options[i].text.includes(variant)) {
            select.selectedIndex = i;
            select.dispatchEvent(new Event('change'));
            break;
          }
        }
      }
    });
  });
});
document.querySelectorAll('.color-swatches .swatch').forEach(swatch => {
  swatch.addEventListener('click', function() {
    const variant = this.getAttribute('data-variant');
    const select = document.querySelector('select[name="options[Couleur]"]');
    if (select) {
      select.value = variant;
      select.dispatchEvent(new Event('change'));
    }
  });
});
